import { parseFullName } from "parse-full-name";

import { compactStrings } from "@src/shared/utils/strings";

export type UserNameParts = {
  firstName?: string | null;
  lastName?: string | null;
};

export type UserEmailVerification = {
  emailVerified: boolean;
};

export const UserEntity = {
  initials(user: UserNameParts): string {
    const parsed = parseFullName(
      compactStrings([user.firstName, user.lastName]).join(" "),
    );

    return compactStrings([parsed.first, parsed.last])
      .map((part) => part.at(0))
      .join("")
      .toUpperCase();
  },

  isEmailVerified(user: UserEmailVerification): boolean {
    return user.emailVerified;
  },
} as const;
